import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RegistrationSharedService } from '../registration-shared.service';

@Injectable({
  providedIn: 'root',
})
export class StepCustomerInfoGuard  {
  private registrationSharedService = inject(RegistrationSharedService);
  private router = inject(Router);
  
  constructor() {}

  canActivate(): boolean {
    if (this.registrationSharedService.registrationData.establishment.countryCode) {
      return true;
    }

    document.location.href = '/';
    return false;
  }
}
